<div class="sem-permissao-container">
  <div class="sem-permissao-content">
    <i class="pi pi-lock sem-permissao-icon" aria-hidden="true"></i>
    <h2 class="sem-permissao-titulo">{{ texts.titulo }}</h2>
    <p class="sem-permissao-mensagem">{{ texts.mensagem }}</p>
    <button pButton
            icon="pi pi-arrow-left"
            [label]="texts.voltar"
            severity="secondary"
            class="sem-permissao-botao"
            (click)="voltar()">
    </button>
  </div>
</div>
